import LazyVideo from "../components/LazyVideo";

export default function WalksOfLight() {
  return (
    <div className="bg-gradient-to-t from-slate-100 to-royalBlue ">
      {/*
       */}

      {/*  */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-4 p-4 max-w-screen-xl mx-auto">
        {/* Horizontal Text Box - Move this BELOW the first horizontal image to appear on second row */}
        <div className="col-span-1 sm:col-span-2 lg:col-span-2 row-span-1 aspect-video bg-white rounded-2xl shadow-md p-6 flex items-center justify-center text-center">
          <div>
            <h1 className="text-royalBlue text-xl font-semibold  pt-4">
              🎬 Walks of Light: Shining a Lens on Mental Health
            </h1>
            <p className="text-s text-gray-800">
              G.C.M. Production collaborated with Walks of Light (WOL) to direct
              a powerful video series highlighting their mission to normalize
              mental health conversations. Through workshops, support groups,
              and community events, WOL brings people together — and we captured
              it all through authentic, heartfelt directing that helps amplify
              their message and impact.
            </p>
          </div>
        </div>
        {/* Vertical Video */}
        <div className="col-span-1 sm:col-span-1 lg:col-span-2 row-span-2 bg-black rounded-2xl overflow-hidden shadow-md">
          <LazyVideo
            className="w-full h-full  object-cover"
            src="../Imgs/WalksOfLight/Walks of light.MP4"
            autoPlay
            muted
            loop
            controls
            playsInline
          />
        </div>

        {/* Vertical Video */}
        <div className="col-span-1 sm:col-span-1 lg:col-span-2 row-span-2 bg-black rounded-2xl overflow-hidden shadow-md">
          <LazyVideo
            className="w-full h-full object-cover"
            src="../Imgs/WalksOfLight/Walks of light - Rafael (Directing).MP4"
            autoPlay
            muted
            loop
            controls
            playsInline
          />
        </div>
        {/* Vertical Video */}
        <div className="col-span-1 sm:col-span-1 lg:col-span-2 row-span-2 bg-black rounded-2xl overflow-hidden shadow-md">
          <LazyVideo
            className="w-full h-full object-cover"
            src="../Imgs/WalksOfLight/TimesSquareWOL.mov"
            autoPlay
            muted
            loop
            controls
            playsInline
          />
        </div>

        {/* Vertical Image */}
        <div className="col-span-1 sm:col-span-1 lg:col-span-1 row-span-1 bg-gray-100 rounded-2xl overflow-hidden shadow-md">
          <img
            src="../Imgs/WalksOfLight/WalksOfLightTimeSquareBlue.jpg"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>

        {/* Vertical Image */}
        <div className="col-span-1 sm:col-span-1 lg:col-span-1 row-span-1 bg-gray-100 rounded-2xl overflow-hidden shadow-md">
          <img
            src="../Imgs/WalksOfLight/WalksOfLightGreenBG.jpg"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>

        {/* Horizontal Text Box - Move this BELOW the first horizontal image to appear on second row */}
        <div className="col-span-1 sm:col-span-2 lg:col-span-3 row-span-1 aspect-video bg-white rounded-2xl shadow-md p-6 flex items-center justify-center text-center lg:grid-cols-2">
          <div>
            <h1 className="text-royalBlue text-3xl pt-2 font-semibold">
              Behind the Scenes of Walks of Light
            </h1>
            <p className="text-m text-gray-800"></p>
          </div>
        </div>

        {/* Horizontal Image */}
        <div className="col-span-1 sm:col-span-2 lg:col-span-2 row-span-1 bg-black rounded-2xl overflow-hidden shadow-md">
          <img
            src="../Imgs/WalksOfLight/bts.jpg"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        {/* Vertical Video */}
        <div className="col-span-1 sm:col-span-1 lg:col-span-1 row-span-2 bg-black rounded-2xl overflow-hidden shadow-md">
          <LazyVideo
            className="w-full h-full object-cover"
            src="../Imgs/WalksOfLight/NoSoundBehindtheScenesWalksofLight.mov"
            controls
          />
        </div>
      </div>
    </div>
  );
}
